module.exports = __webpack_public_path__ + "img/layout-split.f6f77031.svg";